import { ArrowLeft } from 'lucide-react';

import { Button, type ButtonProps } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/cn';

export interface PageHeaderBackButtonProps extends Omit<
  ButtonProps,
  'children'
> {
  className?: string;
}

export const PageHeaderBackButton = (props: PageHeaderBackButtonProps) => {
  const { className, ...rest } = props;

  return (
    <Button {...rest} variant="ghost" className={cn('px-0', className)}>
      <ArrowLeft />
      <span>Back</span>
    </Button>
  );
};
